



























































































































































































































































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { Mutation, State } from "vuex-class";
import Daterange from "@/mixins/daterange";
import { BusinessContactsTextConfig } from "@/config";
import * as api from "@/service/step-three";
import VueQr from 'vue-qr'

@Component({
  components: {
    VueQr,
  }
})
export default class BusinessContacts extends Mixins(Daterange) {
  @Prop({ required: true, type: Object }) form!: any;
  @State bidType!: number;
  @Mutation setChannel!: Function;

  purchaseList: any = [];
  channelType = {
    "1": "小芒平台",
    "2": "MT星球",
  };
  codeUrl: string = ''
  timer: any = null
  verifyCode: string = ''
  verifyResult: number = 0
  frontVerifyResult: number = 0
  backVerifyResult: number = 0
  previewType: string = ''
  modalVisible = false;
  previewMap: any = {
    'idFront': require('@/assets/image/id-front-eg.jpg'),
    'idBack': require('@/assets/image/id-back-eg.jpg'),
    'idHandIn': require('@/assets/image/id-handin.png'),
    'auth1': require('@/assets/image/authorize1-eg.jpg'),
    'auth2': require('@/assets/image/authorize2-eg.jpg'),
    'authorization': require('@/assets/image/authorization-eg.jpeg'),
  }

  get showVerifyCode() {
    return this.bidType == 8 && !!this.form.person_name && !!this.form.person_idcard && this.form.person_card_type == '1'
  }

  get showLicenseFields() {
    return this.bidType == 6 || (this.bidType !== 6 && (!!this.form.idcard_due_url && this.form.idcard_back_url))
  }

  get idTips() {
    let frontText = '法定代表人证件正面照片',
      backText = '法定代表人证件反面照片'
    if (this.bidType == 7 || this.bidType == 8) {
      frontText = '身份证正面',
      backText = '身份证反面'
    }
    const str =
      this.frontVerifyResult == -1
        ? this.backVerifyResult == -1
          ? frontText + '、' + backText
          : frontText
        : this.backVerifyResult == -1
        ? backText
        : ''
    return str
      ? str +
          '图片识别失败，将影响下方自动识别填入信息，可重新上传或手动填写信息'
      : ''
  }

  get hrefUrl() {
    const { NODE_ENV, TARGET } = process.env;
    return NODE_ENV === "development" || TARGET === "test-build"
      ? "http://dev.xiaomang.mgtv.com/categories"
      : "https://xiaomang.mgtv.com/categories";
  }

  get rules() {
    return {
      person_name: [
        {
          required: true,
          message: `请填写${this.getTextConfig["person_name"]["label"]}`,
        },
      ],
      ...(this.bidType === 7 ||
      this.bidType === 8 ||
      (this.bidType === 2 && this.form.coop_channel === 2)
        ? {
            person_mobile: [
              {
                required: true,
                message: `请填写${this.getTextConfig["person_mobile"]["label"]}`,
              },
            ],
          }
        : {}),
      ...(this.bidType === 2
        ? { coop_channel: [{ required: true, message: "请选择合作渠道" }] }
        : {}),
      person_card_type: [
        {
          required: this.bidType !== 6,
          message: `请选择${this.getTextConfig["person_card_type"]["label"]}`,
        },
      ],
      person_idcard: [
        {
          required: this.bidType !== 6,
          message: `请填写${this.getTextConfig["person_idcard"]["label"]}`,
        },
        { pattern: /^[a-zA-Z0-9]+$/, message: "证件号码只允许包含字母或数字" },
      ],
      ...(this.bidType === 2 && this.form.coop_channel === 2
        ? {}
        : {
            finance_contacts: [
              { required: true, message: "请填写财务联系人姓名" },
            ],
            finance_contacts_phone: [
              { required: true, message: "请填写财务联系人手机" },
            ],
            aftersale_contacts: [
              { required: true, message: "请填写售后联系人姓名" },
            ],
            aftersale_contacts_phone: [
              { required: true, message: "请填写售后联系人手机" },
            ],
            deliver_contacts: [
              { required: true, message: "请填写发货联系人姓名" },
            ],
            deliver_contacts_phone: [
              { required: true, message: "请填写发货联系人手机" },
            ],
          }),
      business_contacts: [{ required: true, message: "请填写业务联系人姓名" }],
      business_contacts_phone: [
        { required: true, message: "请填写业务联系人手机" },
      ],
      authorize_url: [
        {
          required: true,
          message: `请上传${
            this.bidType === 2 && this.form.coop_channel === 2
              ? "商家入驻确认函"
              : this.getTextConfig["authorize_url"]["label"]
          }`,
        },
      ],
      idcard_due_url: [
        { required: true, validator: this.validateIdcard.bind(this) },
      ],
      idcard_hand_url: [
        { required: true, message: '请上传手持身份证照片' },
      ],
      contact_front_url: [
        { required: true, validator: this.validateContactCard.bind(this) },
      ],
      business_contacts_email: [
        { required: true, message: "请填写业务联系人邮箱" },
        { type: "email", message: "邮箱格式不正确" },
      ],
      cert_start_date: [
        {
          required: true,
          message: "请选择证件有效期起始日期",
          trigger: ["blur", "change"],
        },
      ],
      cert_end_date: [
        {
          required: true,
          message: "请选择证件有效期截止日期",
          trigger: ["blur", "change"],
        },
      ],
      ...this.bidType == 6 ? {
        person_card_type: [
          {
            required: true,
            message: "请选择法定代表人证件类型",
            trigger: ["blur", "change"],
          },
        ],
        person_idcard: [
          {
            required: true,
            message: "请输入法定代表人证件号码",
            trigger: ["blur", "change"],
          },
        ],
      } : {}
    };
  }
  get cardType() {
    const base: any = {
      "1": "中国居民身份证",
      "2": "护照",
      "3": "港澳居民来往内地通行证（回乡证）",
      "4": "台湾居民来往大陆通行证（台胞证）",
    };
    // if (this.bidType === 6) delete base[1];
    return base;
  }

  get antForm() {
    return this.$refs.form as any;
  }
  get getTextConfig() {
    if (this.bidType === 7) {
      return BusinessContactsTextConfig.personal;
    }
    if (this.bidType === 8) {
      return BusinessContactsTextConfig.artist;
    }
    return BusinessContactsTextConfig.normal;
  }
  created() {
    if (this.showVerifyCode) {
      if (this.form.face_status == void 0) this.fetchFaceInfo()
      else {
        this.verifyResult = this.form.face_status == 1 ? 1 : -1
        this.fetchFaceInfo(false)
      }
    }
    this.onEndDateChange(this.form.cert_end_date);
  }
  mounted() {
    this.getPurchaserList();
  }
  beforeDestroy() {
    this.clearLoop()
  }
  getPurchaserList() {
    api.queryPurchaseList().then((data: any) => {
      this.purchaseList = data.list;
    });
  }
  changeChannel(value: any) {
    this.setChannel(value);
  }

  async handleIdCardChange(info: any, card_side: string = 'front') {
    if(this.form.person_card_type != '1') return
    ; (this.$refs.form as any).validateField('idcard_due_url')
    if (card_side == 'front') this.frontVerifyResult = 0
    else this.backVerifyResult = 0
    this.verifyResult = 0
    if (info.fileList?.length <= 0) {
      this.codeUrl = ''
      this.verifyResult = 0
      this.clearLoop()
      ;(this.$refs.form as any)?.clearValidate(['person_name', 'person_mobile', 'person_idcard', 'cert_start_date', 'cert_end_date'])
      return
    }
    try {
      const data = await api.queryIdCardInfo({
        img_url: card_side == 'front' ? this.form.idcard_due_url : this.form.idcard_back_url,
        card_side,
      })
      if (card_side == 'front') this.frontVerifyResult = 1
      else this.backVerifyResult = 1
      let obj: any = {}
      if (card_side == 'front') {
        obj = {
          person_name: data.name,
          person_idcard: data.card_no,
        }
      } else {
        obj = {
          cert_start_date: data.sign_date?.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'),
          cert_end_date: data.expire_date?.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
        }
        this.setEndDate(data.expire_date?.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'))
      }
      this.$emit('change', obj)
      await this.$nextTick()
      if (
        this.showVerifyCode &&
        this.form.idcard_due_url &&
        this.form.idcard_back_url
      )
        this.fetchFaceInfo()
    } catch (e) {
      if (card_side == 'front') this.frontVerifyResult = -1
      else this.backVerifyResult = -1
    }
  }

  async fetchFaceInfo(needQueryResult: boolean = true) {
    this.clearLoop()
    if (this.form.person_card_type != 1) {
      this.verifyResult = 1
      this.$emit('change', {
        face_status: 1
      })
      return
    }
    try {
      this.codeUrl = ''
      const data = await api.queryFaceIdCardInfo({
        id_name: this.form.person_name,
        id_no: this.form.person_idcard,
        certificate_type: 0
      })
      this.verifyCode = data.verify_token
      this.codeUrl = `https://brain.baidu.com/face/print/?token=${data.verify_token}`
      if (needQueryResult) this.setResultLoop()
    }catch(e) {}
  }

  async fetchFaceResult() {
    try {
      const data = await api.queryFaceResult(this.verifyCode)
      if (!!data) { 
        if (!!data.image) this.verifyResult = 1
        else this.verifyResult = -1
      }
    } catch (e) {
      if (e && (e as any).code != 283450) {
        this.verifyResult = -1
      }
    }
  }

  setResultLoop() {
    clearTimeout(this.timer)
    this.timer = null
    this.timer = setTimeout(async () => {
      await this.fetchFaceResult()
      if (this.verifyResult != 0) {
        clearTimeout(this.timer)
        this.timer = null
        this.$emit('change', {
          face_status: this.verifyResult == 1 ? 1 : 0
        })
      } else {
        this.setResultLoop()
      }
    }, 3000)
  }

  clearLoop() {
    clearTimeout(this.timer)
    this.timer = null
  }

  validateIdcard(rule: any, value: string, callback: any) {
    const { idcard_due_url, idcard_back_url } = this.form;
    if (!idcard_due_url) {
      callback(new Error(`请上传${this.bidType == 6 ? '法定代表人' : ''}证件正面照片`));
      return;
    }
    if (!idcard_back_url) {
      callback(new Error(`请上传${this.bidType == 6 ? '法定代表人' : ''}证件反面照片`));
      return;
    }
    callback();
  }
  validateContactCard(rule: any, value: string, callback: any) {
    const { contact_front_url, contact_back_url } = this.form;
    if (!contact_front_url) {
      callback(new Error("请上传证件正面照片"));
      return;
    }
    if (!contact_back_url) {
      callback(new Error("请上传证件反面照片"));
      return;
    }
    callback();
  }

  async setEndDate(val: string) {
    this.$set(this.form, "cert_end_date", val);
    await this.$nextTick();
    this.antForm.validateField("cert_end_date");
  }

  @Watch("form.cert_end_date")
  initEndDate(val: string) {
    this.onEndDateChange(val);
  }

  validate() {
    return new Promise((resolve) => {
      this.antForm.validate((valid: boolean, e: any) => {
        if (valid) { 
          if (this.showVerifyCode && (this.verifyResult == 0 || (this.verifyResult == -1 && !this.form.idcard_hand_url))) {
            this.$message.error('请先进行实名认证')
            resolve(false)
            return
          }
          resolve(valid)
        } else {
          const err: any = Object.values(e)[0]
          this.$message.error(err[0].message)
          resolve(valid)
        }
      })
    })
  }

  handleValueChange(value: any, prop: string) {
    if (this.bidType == 8) {
      if (prop == 'person_card_type') {
        if (value != 1) {
          this.clearLoop()
          this.verifyResult = 1
          this.$emit('change', {
            face_status: 1
          })
        } else {
          this.verifyResult = 0
          if (this.form.idcard_due_url && this.form.idcard_back_url)
            this.fetchFaceInfo()
        }
      } else if (value != this.form[prop]) {
        this.verifyResult = 0
        this.fetchFaceInfo()
      }
    }
  }
}
